import { AxiosResponse } from 'axios'
import { Moment } from 'moment'
import { RequestREAD, RequestCDU } from 'services/Instances'

export const DjurServices = () => {
  const path = 'AtendimentoDjur'

  const deleteAnexoEvidencia = async (
    idEvidenciaDjur: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete(
      `${path}/DeleteDocAnexoEvidencia/${idEvidenciaDjur}`
    )

  const searchDjur = async (
    params: IGetPaginatedSearchDjur
  ): Promise<AxiosResponse<ISearchDjur>> =>
    await RequestREAD.get(`${path}/GetPaginatedSearchWithParams`, {
      params: params
    })

  const getInfoAtendimentoDjur = async (
    requestObj: IRequestConsultAnalyzeDjur
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(`${path}/GetInfoAtendimentoDjur`, requestObj)

  const getDataLock = async (
    NuProcesso: string
  ): Promise<AxiosResponse<IDataLockItems[]>> =>
    await RequestREAD.get(`${path}/DadosDeBloqueio`, {
      params: {
        NuProcesso
      }
    })

  const getExistingClaimantHistory = async (
    cpfReclamante: string,
    periodoReclamacao?: IGetExistingClaimantHistoryBody | {}
  ): Promise<AxiosResponse<ClaimantHistoryResponse>> => {
    const body = periodoReclamacao || {}
    const params = {
      cpfReclamante
    }
    return await RequestREAD.post(`${path}/HistoricoDoReclamanteELupa`, body, {
      params
    })
  }

  const getAddingClaimantHistory = async (
    cpf: string
  ): Promise<AxiosResponse<IClaimantHistoryAddingNew[]>> =>
    await RequestREAD.get(`${path}/HistoricoDoReclamanteELupaGetCadastro`, {
      params: {
        cpfColaborador: cpf
      }
    })

  const requestData = async (
    cpf: string
  ): Promise<AxiosResponse<IRequestData>> =>
    await RequestREAD.get(`${path}/DadosDaSolicitacao`, {
      params: {
        cpfReclamante: cpf
      }
    })

  const getDocuments = async (
    params: IGetDocumentsParams
  ): Promise<AxiosResponse<IDocumentsResponse>> =>
    await RequestREAD.get(`${path}/DocumentosAtendimentoDjur`, {
      params: params
    })

  const getDjurDocuments = async (
    atendimentoDjurId: number
  ): Promise<AxiosResponse<DjurDocumentsResponse>> =>
    await RequestREAD.get(`${path}/DocumentosParaDjur`, {
      params: { atendimentoDjurId }
    })

  const uploadDjurDocuments = async (
    djurArray: IDjurToUpload[]
  ): Promise<AxiosResponse<unknown>> => {
    const body = djurArray
    return await RequestCDU.post(
      'AnexoDocParaDjur/CreateAnexoDocParaDjur',
      body
    )
  }

  const deleteDjurDocuments = async (
    djurDocIds: number[]
  ): Promise<AxiosResponse<any>> => {
    const body = djurDocIds
    return await RequestCDU.delete('AnexoDocParaDjur/DeleteAnexoDocParaDjur', {
      data: body
    })
  }

  const getDocumentTypes = async (): Promise<
    AxiosResponse<DocumentTypesResponse>
  > => await RequestREAD.get('TipoPendencia')

  const autoCompleteEmailMatricula = async (
    params: IAutoCompleteEmailMatriculaParams
  ): Promise<AxiosResponse<IAutoCompleteEmailMatriculaResponse>> =>
    await RequestREAD.get(`${path}/EmailAndMatricula`, {
      params: params
    })

  const sendDjurToEmail = async (
    body: ISendDjurToEmail
  ): Promise<AxiosResponse<unknown>> =>
    await RequestCDU.post(`${path}/DisparoEmailParaDjur`, body)

  const getEvidences = async (
    AtendimentoDjurId: number
  ): Promise<AxiosResponse<EvidencesResponse>> =>
    await RequestREAD.get(`${path}/AnexosEvidencia`, {
      params: {
        AtendimentoDjurId
      }
    })

  const attachEvidences = async (
    evidences: IEvidencesTable
  ): Promise<AxiosResponse<any>> => {
    const body = evidences
    return await RequestCDU.post(
      'AnexarDocEvidenciaDjur/CreateAnexarDocEvidenciaDjur',
      body
    )
  }

  const deleteEvidences = async (
    evidencesIds: IEvidencesToDelete
  ): Promise<AxiosResponse<any>> => {
    const body = evidencesIds
    return await RequestCDU.delete(
      'AnexarDocEvidenciaDjur/DeleteAnexarDocEvidenciaDjur',
      { data: body }
    )
  }

  // Cria um Djur vazio quando for adicionar novo,
  // pra ter um id antes de salvar tudo de uma vez
  const createDjur = async (
    djurData: ICreateDjurRequestBody
  ): Promise<AxiosResponse<AnexosEvidenciaResponse>> => {
    const body = djurData
    return await RequestCDU.post('AtendimentoDjur/CreateAtendimentoDjur', body)
  }

  // Salvar tudo de uma vez
  const createAndEditDjur = async (
    djurData: ICreateAndEditDjur
  ): Promise<AxiosResponse<any>> => {
    const body = djurData
    return await RequestCDU.post(
      'AtendimentoDjurFull/CreateAtendimentoDjurFull',
      body
    )
  }

  const CreateDocAnexoEvidencia = async (
    data: IAnexoEvidenciaDjur[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/CreateDocAnexoEvidencia`, data)

  const searchMatriculaEmail = async (
    params: ISearchMatriculaEmail
  ): Promise<AxiosResponse<IMatriculaEmailSearchResponse[]>> =>
    await RequestREAD.get(`${path}/BuscarPorEmailOuMatricula`, { params })

  const uploadAnexoEvidencia = async (
    body: IUploadAnexo[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/CreateDocAnexoEvidencia`, body)

  const searchReclamanteByCpfPassaporte = async (
    params: ISearchReclamanteByCpfPassaporteParams
  ): Promise<AxiosResponse<ISearchReclamanteByCpfPassaporteReturn>> =>
    await RequestREAD.get(`${path}/GetDadosUsuario`, { params })

  return {
    searchReclamanteByCpfPassaporte,
    uploadAnexoEvidencia,
    searchMatriculaEmail,
    deleteAnexoEvidencia,
    attachEvidences,
    autoCompleteEmailMatricula,
    createAndEditDjur,
    createDjur,
    deleteDjurDocuments,
    deleteEvidences,
    CreateDocAnexoEvidencia,
    getAddingClaimantHistory,
    getDataLock,
    getDjurDocuments,
    getDocumentTypes,
    getDocuments,
    getEvidences,
    getExistingClaimantHistory,
    getInfoAtendimentoDjur,
    requestData,
    searchDjur,
    sendDjurToEmail,
    uploadDjurDocuments
  }
}

interface ISearchReclamanteByCpfPassaporteParams {
  CpfPassaporte: string
}

interface ISearchReclamanteByCpfPassaporteReturn {
  idMovEfetivo: number
  nomeEfetivo: string
  cpfpassaporte: string
}

export interface ICreateDjurRequestBody {
  atendimentoDjurInfo: {
    idAtendimentoDjur: number
    atendimentoDjurPendenciaId: number
    contratoId: number
    cdContrato: string
    cdAtendimentoDjur: string
    txObservacaoRetorno: string
    nuValorCausa: number
    txTipo: string
    nuProcesso: string
    dtInicioReclamacao: Date
    dtFimReclamacao: Date
    dtEntrada: Date | string
    dtRetorno: Date | string
    nmReclamante: string
    cpfReclamante: string
    chamadoCervelo: string
    // nuAnalises: number;
  }
  anexoDocParaDjur: {
    atendimentoDjurId: number
    idDocumentoParaDjur: number
    idMovDocumento: number
  }[]
  disparoEmailParaDjur: {
    email: string
    flEnviarDocumentos: boolean
  }
}

export interface AtendimentoDjurResponse {
  idAtendimentoDjur: number
  contratoId: number
  cdContrato: string
  cdAtendimentoDjur: number
  txObservacaoRetorno: string
  nuValorCausa: number
  txTipo: string
  nuProcesso: string
  dtInicioReclamacao: Date
  dtFimReclamacao: Date
  dtEntrada: Date
  dtRetorno: Date
  nmReclamante: string
  cpfReclamante: string
  chamadoCervelo: string
  nuAnalises: number
}

export interface AnexoDocParaDjur {
  atendimentoDjurId: number
  fornecedorId: number
  contratoId: number
  flAtivo: boolean
  txDescricao: string
  txFilePath: string
  txFileName: string
  dtAnexo: Date
  file: string
  nuAnoMesCompetencia: Date
}

export interface AnexarDocEvidenciaDjur {
  idDocumentoParaDjur: number
  idMovDocumento: number
  atendimentoDjurId: number
}

export interface DisparoEmailParaDjur {
  email: string
  flEnviarDocumentos: boolean
}

export interface AtendimentoDjurNuAnalises {
  dtRetorno: Date
  idAtendimentoDjur: number
}

export interface Valor {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
  atendimentoDjurRequestDto: AtendimentoDjurRequestDto
  anexarDocEvidenciaDjurRequestDto: AnexarDocEvidenciaDjur[]
  anexoDocParaDjurRequestDto: AnexoDocParaDjur[]
  disparoEmailParaDjurRequestDto: DisparoEmailParaDjur
  atendimentoDjurNuAnalisesDTo: AtendimentoDjurNuAnalises
}

export interface AnexosEvidenciaResponse {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
  valor: Valor
}

interface IUploadAnexo {
  atendimentoDjurId: number
  descricaoArquivo: string
  titulo: string
  arquivo: string //base64
}

interface ISearchMatriculaEmail {
  searchParam: string
  flMatricula: boolean
}

export interface IMatriculaEmailSearchResponse {
  txEmail: string
  nmMatricula: string
  flHasEmail: boolean
}

export interface IDjur {
  cdContrato: string
  cdAtendimentoDjur: string
  chamadoCervelo: string
  cdDocto: string
  nmFornecedor: string
  cpfReclamante: string
  nuProcesso: number
  idAtendimentoDjur?: number
  idContrato?: number
  idForneedor?: number
  processoReclamante?: string
}

export interface IGetPaginatedSearchDjur {
  pageNumber: number
  pageSize: number
  cdContrato?: string
  numeroAtendimentoDjur?: string
  cervello?: string
  cnpjCpfPassaporte?: string
  nomeFornecedor?: string
  cpfPassaporte?: string
  numeroProcesso?: string
}

export interface ISearchDjurItems {
  idAtendimentoDjur: number
  codigoContrato: string
  idContrato: number
  cdAtendimentoDjur: string
  cervello: string
  cnpjFornecedor: string
  nomeFornecedor: string
  tipo: string
  cpfReclamante: string
  processoReclamante: string
}

export interface ISearchDjur {
  pageCount: number
  items: ISearchDjurItems[]
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
}

export interface IRequestData {
  cdContrato: {
    cdContrato: string
    idContrato: number
  }
  chamadoCervelo: string
  cpfReclamante: string
  dtEntrada: Date | string | null | any | Moment
  dtFimReclamacao: Date | string | null | any
  dtInicioReclamacao: Date | string | null | any
  dtRetorno: Date | string | null | any
  idAtendimentoDjur: number | any
  nmReclamante: string
  nuAnalises: number
  nuProcesso: string
  valorContratual: number
  txObservacaoRetorno: string
  tipoPendenciaId?: number
  tipoProcesso?: string
}

export interface IAnexoEvidenciaDjur {
  descricaoArquivo: string
  titulo: string
  arquivo: string
  atendimentoDjurId: number
}

export interface IDataLockItems {
  cdContrato: string
  vlLiquido: number
  nuDocumento: number
}

export interface IClaimantHistory {
  cdContrato: string
  cdDocto: string
  cdStatus: string
  idAtendimentoDjur: number | any
  nmFornecedor: string
  nmReclamante: string
  nuAnoMesCompetencia: string
  txDescricao: string
}

export type ClaimantHistoryResponse = IClaimantHistory[]

export interface IClaimantHistoryAddingNew {
  idMovEfetivo: number
  nmColaborador: string
  cdDocto: string
  nmFornecedor: string
  cdContrato: string
  txDescricao: string
  nuAnoMesCompetencia: string
  cdStatus: string
}

export type IClaimantHistoriesArray =
  | IClaimantHistory[]
  | IClaimantHistoryAddingNew[]

export interface IGetExistingClaimantHistoryBody {
  dtInicioReclamacao: Date | string | null | any
  dtFimReclamacao: Date | string | null | any
}
export interface IDocumentType {
  idTipoPendencia?: number
  idAtendimentoDjurPendencia?: number
  txDescricao: string
}

export type DocumentTypesResponse = IDocumentType[]

export interface IGetDocumentsParams {
  cdContrato: string
  IdTipoPendencia: number
  DtCompetenciaInicio: string
  DtCompetenciaFim: string
}

export interface IGetDocument {
  idMovDocumentoItem: number
  idContrato: number
  idTipoPendencia: number
  cdContrato: string
  cdGedExternalId: string
  txFileName: string
  txDescricao: string
  nuAnoMesCompetencia: number
  txTipoPendencia: string
}

export type IDocumentsResponse = IGetDocument[]

export interface IDjurDocument {
  idDocumentoParaDjur: number
  cdContrato: string
  txTipoPendencia: string
  tipoPendenciaId: number
  nuAnoMesCompetencia: number
  cdGedExternalId: string
  flAtivo: boolean
  txFileName: string
  txDescricao: string
}

export type DjurDocumentsResponse = IDjurDocument[]

export interface IDjurToUpload {
  idDocumentoParaDjur: number
  atendimentoDjurId: number
  tipoPendenciaId: number
  contratoId: number
  fornecedorId: number
  flAtivo: boolean
  dtAnexo: string
  txDescricao: string
  txFilePath: string
  txFileName: string
  nuAnoMesCompetencia: number
  file: string
}

export interface IAutoCompleteEmailMatriculaParams {
  nmMatricula?: string
  txEmail?: string
}

export interface IAutoCompleteEmailMatriculaResponse {
  nmMatriculas: IAutoCompleteEmailMatriculaResult[]
  txEmails: IAutoCompleteEmailMatriculaResult[]
}

export interface IAutoCompleteEmailMatriculaResult {
  id: number
  matricula: string
  email: string
}

export interface ISendDjurToEmail {
  idDocumentoParaDjur: number
  email: string
  nmMatricula: string
}
export interface IEvidence {
  idDocumentoEvidenciaDjur?: number
  atendimentoDjurId: number
  fornecedorId?: number
  contratoId?: number
  flAtivo?: boolean
  txDescricao: string
  txFilePath?: string
  txFileName: string
  dtAnexo?: string
  file?: string
  nuAnoMesCompetencia?: string
  cdGedExternalId?: number
}

export type IEvidencesTable = IEvidence[]

export type IEvidencesToDelete = number[]

export interface IGetEvidence {
  atendimentoDjurId: number
  txFileName: string
  txDescricao: string
  cdGedExternalId: number
  flAtivo: boolean
}

export type EvidencesResponse = IGetEvidence[]

export interface ICreateDjur {
  idAtendimentoDjur?: number
  contratoId: number
  tipoPendenciaId: number
  cdAtendimentoDjur?: string
  txObservacaoRetorno: string
  nuValorCausa: number
  nuProcesso: string
  dtInicioReclamacao: Date | Moment | string | null
  dtFimReclamacao: Date | Moment | string | null
  dtEntrada: Date | Moment | string | null
  dtRetorno: Date | Moment | string | null
  nmReclamante: string
  cpfReclamante: string
  chamadoCervelo: string
  nuAnalises: number
}

export type AtendimentoDjurRequestDto = ICreateDjur

export interface AnexarDocEvidenciaDjurRequestDto {
  idDocumentoEvidenciaDjur: number
  atendimentoDjurId: number
  fornecedorId: number
  contratoId: number
  flAtivo: boolean
  txDescricao: string
  txFilePath: string
  txFileName: string
  dtAnexo: Date | Moment | string | null
  file: string
  nuAnoMesCompetencia: string
}

export interface AnexoDocParaDjurRequestDto {
  idDocumentoParaDjur: number
  atendimentoDjurId: number
  tipoPendenciaId: number
  contratoId: number
  fornecedorId: number
  flAtivo: boolean
  dtAnexo: string
  txDescricao: string
  txFilePath: string
  txFileName: string
  nuAnoMesCompetencia: number
  file: string
}

export interface DisparoEmailParaDjurRequestDto {
  idDocumentoParaDjur: number
  email: string
  nmMatricula: string
}

export interface AtendimentoDjurNuAnalisesDTo {
  dtRetorno: Date | Moment | string | null
  idAtendimentoDjur: number
}

export interface ICreateAndEditDjur {
  atendimentoDjurRequestDto: AtendimentoDjurRequestDto
  anexarDocEvidenciaDjurRequestDto: AnexarDocEvidenciaDjurRequestDto[]
  anexoDocParaDjurRequestDto: AnexoDocParaDjurRequestDto[]
  disparoEmailParaDjurRequestDto: DisparoEmailParaDjurRequestDto
  atendimentoDjurNuAnalisesDTo: AtendimentoDjurNuAnalisesDTo
}

export interface IRequestConsultAnalyzeDjur {
  pageNumber?: number
  pageSize?: number
  flReanalise?: boolean
  idAtendimentoDjur?: number
  cpfReclamante?: string
  flHistoricoReclamante?: boolean
  flDadosSolicitacao?: boolean
  flDadosBloqueio?: boolean
  flDocumentos?: boolean
  flDocumentosParaDjur?: boolean
  flAnexarEvidencias?: boolean
  idTipoPendencia?: number
  cdContrato?: string
  competenciaInicio?: string
  competenciaFim?: string
  nuProcesso?: string
}

export interface IClaimantHistoriesItems {
  cnpj: string
  fornecedor: string
  contrato: string
  nmCentro: string
  competencia: string
  status: string
}

export interface ILockDataItems {
  codigoContrato: string
  folhaRegistro: string
  valor: string
  motivoBloqueio: string
}

export interface IDocsItems {
  checked?: boolean
  localId?: string
  atendimentoDjurId?: number
  idDocumentoParaDjur?: number
  file?: string
  txFileName?: string
  idContrato: number
  contrato: string
  movDocumentoItemId: string
  movDocumentoId: number
  idTipoPendencia: number
  txDescricaoPendencia: string
  idRolDocumento: number
  nmRolDocumento: string
  idDocumentoGed: number
  competencia: string
  idMovDocumento?: number
  contratoId?: number
}

export interface IEvidenceItems {
  evidenciaId: number
  nomeArquivo: string
  localId?: string
  descricaoArquivo: string
  cdGedExternalId?: number
  file?: string
  idEvidenciaDjur?: number
}

export interface IResponseConsultAnalyzeDjur {
  idAtendimentoDjur: number
  dadosSolicitacao: {
    inicioReclamacao: string
    fimReclamacao: string
    cervelo: string
    numeroAnalises: number
    cpfReclamante: string
    nomeReclamante: string
    numeroProcesso: string
    cdContrato: string
    idContrato: number
    valorContratual: number
    tipo: string
    dataEntrada: string
    dataRetorno: string
    observacaoRetorno: string
  }
  historicoReclamante: {
    pageCount: number
    items: IClaimantHistoriesItems[]
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
  dadosBloqueio: {
    pageCount: number
    items: ILockDataItems[]
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
  documento: {
    pageCount: number
    items: IDocsItems[]
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
  documentosParaDjur: {
    pageCount: number
    items: IDocsItems[]
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
  anexarEvidencias: {
    pageCount: number
    items: IEvidenceItems[]
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
}
